import {
  $,
  component$,
  type JSX,
  useOnDocument,
  useVisibleTask$,
  useSignal,
} from '@builder.io/qwik';
import type { SportradarProp } from '~/types/SportradarTypes';

export default component$(
  ({
    dataId,
    language,
    widgetId,
    teamUid,
    uniqueTeamId,
    playerId,
    seasonId,
    uniqueTournamentID,
    seasonType,
    pastGames,
    matchId,
    statType,
    sportradarProps,
    class: widgetClass,
    html,
  }: SportradarProp): JSX.Element => {
    const widgetVariables = [
      ...(teamUid ? [`teamUid: ${teamUid}`] : []),
      ...(uniqueTeamId ? [`uniqueTeamId: ${uniqueTeamId}`] : []),
      ...(playerId ? [`playerId: ${playerId}`] : []),
      ...(seasonId ? [`seasonId: ${seasonId}`] : []),
      ...(uniqueTournamentID
        ? [`uniqueTournamentID: ${uniqueTournamentID}`]
        : []),
      ...(seasonType ? [`seasonType: '${seasonType}'`] : []),
      ...(pastGames ? [`pastGames: ${pastGames}`] : []),
      ...(matchId ? [`matchId: ${matchId}`] : []),
      ...(statType ? [`statType: '${statType}'`] : []),
    ].join(', ');
    //const eventLabel = `widgetId: ${widgetId}, ${sportradarProps || widgetVariables}`;

    const sportradarScript = `(function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},
    i.l=1*new Date,i.o=f,g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),
    h.parentNode.insertBefore(g,h))})(window,document,"script",
    "https://widgets.media.sportradar.com/minutemedia/widgetloader","SIR", { language: '${language}' });`;

    const addWidget = `SIR('addWidget', '#sr-widget-${dataId}', '${widgetId}', {border: false, ${sportradarProps || widgetVariables}})`;
    const sportradarRef = useSignal(dataId);

    // eslint-disable-next-line qwik/no-use-visible-task
    useVisibleTask$(() => {
      if (!window.sportradarLoaded) {
        return;
      }

      const scriptElement = document.createElement('script');
      scriptElement.innerHTML = addWidget;
      document.body.appendChild(scriptElement);
    });

    useOnDocument(
      'load',
      $(() => {
        if (window.sportradarLoaded) {
          return;
        }
        window.sportradarLoaded = true;

        const scriptElement = document.createElement('script');
        scriptElement.innerHTML = sportradarScript;
        document.head.appendChild(scriptElement);

        // TODO: implement ticker GA events?
        /*window.mmClientApi = window.mmClientApi || [];

    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'sportradar widget viewable impression',
      event_label: eventLabel,
    });

    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'sportradar widget embed',
      event_label: eventLabel,
    });*/

        const liveStats = document.getElementsByClassName(
          'sr-us-common-linescore-layout__live-stats'
        )[0];

        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (liveStats) {
          // @ts-ignore
          liveStats.style.display = 'none';
        }
      })
    );

    return (
      <div
        data-mm-id={dataId.includes('undefined') ? 'sportradar-widget' : dataId}
        class={widgetClass}
      >
        {html ? (
          <div dangerouslySetInnerHTML={html} />
        ) : (
          <div id={`sr-widget-${dataId}`} ref={sportradarRef} />
        )}
      </div>
    );
  }
);
